import moment from "moment";

export const getToday = () => {
  const today = new Date();
  const ToFrom = {
    from: today.toString(),
    to: today.toString(),
  };
  return ToFrom;
};
//--------------------------------------------
export const getThisweek = () => {
  const ToFrom = {
    from: moment().weekday(0).toString(),
    to: moment().weekday(6).toString(),
  };
  return ToFrom;
};
//-----------------------------------------------
export const getThisweekToDate = () => {
  const today = new Date();
  const firstDayOfWeek = new Date(today);

  firstDayOfWeek.setDate(today.getDate() - today.getDay());

  const ToFrom = {
    from: firstDayOfWeek.toString(),
    to: today.toString(),
  };

  return ToFrom;
};
//-------------------------------------------------

export const getThisMonth = () => {
  const today = new Date();
  const getThisMonthFrom = new Date(today.getFullYear(), today.getMonth(), 1);
  const getThisMonthTo = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const ToFrom = {
    from: getThisMonthFrom.toString(),
    to: getThisMonthTo.toString(),
  };

  return ToFrom;
};
//----------------------------------------------------
export const getThisMonthToDate = () => {
  const today = new Date();
  const getThisMonthFrom = new Date(today.getFullYear(), today.getMonth(), 1);

  const ToFrom = {
    from: getThisMonthFrom.toString(),
    to: today.toString(),
  };

  return ToFrom;
};
//-------------------------------------------------------
export const getThisYear = () => {
  const today = new Date();
  const getThisYearFrom = new Date(today.getFullYear(), 0, 1);
  const getThisYearTo = new Date(today.getFullYear(), 11 + 1, 0);

  const ToFrom = {
    from: getThisYearFrom.toString(),
    to: getThisYearTo.toString(),
  };

  return ToFrom;
};
//----------------------------------------------------------
export const getThisYearToDate = () => {
  const today = new Date();
  const getThisYearFrom = new Date(today.getFullYear(), 0, 1);

  const ToFrom = {
    from: getThisYearFrom.toString(),
    to: today.toString(),
  };

  return ToFrom;
};
//-------------------------------------------------
export const getYesterday = () => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const ToFrom = {
    from: yesterday.toString(),
    to: yesterday.toString(),
  };
  return ToFrom;
};
//------------------------------------------------
export const getLastWeek = () => {
  const today = new Date();
  const lastWeekStart = new Date(today);
  const lastWeekEnd = new Date(today);
  lastWeekStart.setDate(today.getDate() - today.getDay() - 7);
  lastWeekEnd.setDate(lastWeekStart.getDate() + 6);

  const ToFrom = {
    from: lastWeekStart.toString(),
    to: lastWeekEnd.toString(),
  };

  return ToFrom;
};
//------------------------------------------------
export const getLastWeekToDate = () => {
  const today = new Date();
  const lastWeekStart = new Date(today);
  lastWeekStart.setDate(today.getDate() - today.getDay() - 7);

  const ToFrom = {
    from: lastWeekStart.toString(),
    to: today.toString(),
  };

  return ToFrom;
};
//--------------------------------------------------
export const getLastMonth = () => {
  const today = new Date();
  const getLastMonthFrom = new Date(
    today.getFullYear(),
    today.getMonth() - 1,
    1,
  );
  const getLastMonthTo = new Date(today.getFullYear(), today.getMonth(), 0);

  const ToFrom = {
    from: getLastMonthFrom.toString(),
    to: getLastMonthTo.toString(),
  };

  return ToFrom;
};
//-------------------------------------------------
export const getLastMonthToDate = () => {
  const today = new Date();
  const getLastMonthFrom = new Date(
    today.getFullYear(),
    today.getMonth() - 1,
    1,
  );

  const ToFrom = {
    from: getLastMonthFrom.toString(),
    to: today.toString(),
  };

  return ToFrom;
};
//------------------------------------------------------
export const getLastThreeMonths = () => {
  const today = new Date();
  const getLastThreeMonthsFrom = new Date(
    today.getFullYear(),
    today.getMonth() - 3,
    1,
  );
  const getLastThreeMonthsTo = new Date(
    today.getFullYear(),
    today.getMonth(),
    0,
  );

  const ToFrom = {
    from: getLastThreeMonthsFrom.toString(),
    to: getLastThreeMonthsTo.toString(),
  };

  return ToFrom;
};
//------------------------------------------------------
export const getLastSixMonths = () => {
  const today = new Date();
  const getLastSixMonthsFrom = new Date(
    today.getFullYear(),
    today.getMonth() - 6,
    1,
  );
  const getLastSixMonthsTo = new Date(today.getFullYear(), today.getMonth(), 0);

  const ToFrom = {
    from: getLastSixMonthsFrom.toString(),
    to: getLastSixMonthsTo.toString(),
  };

  return ToFrom;
};
//---------------------------------------------------------
export const getLastYear = () => {
  const today = new Date();
  const getLastYearFrom = new Date(today.getFullYear() - 1, 0, 1);
  const getLastYearTo = new Date(today.getFullYear() - 1, 11 + 1, 0);

  const ToFrom = {
    from: getLastYearFrom.toString(),
    to: getLastYearTo.toString(),
  };

  return ToFrom;
};
//---------------------------------------------------------
export const getLastYearToDate = () => {
  const today = new Date();
  const getLastYearFrom = new Date(today.getFullYear() - 1, 0, 1);

  const ToFrom = {
    from: getLastYearFrom.toString(),
    to: today.toString(),
  };

  return ToFrom;
};
